import AddIcon from "@mui/icons-material/Add"
import { Box, CircularProgress, Typography } from "@mui/material"
import React, { useCallback, useContext, useState } from "react"
import { customPalette } from "../../../../../../../../../../theme"
import { BaseButton } from "../../../../../../../../../components/buttons/BaseButton"
import { EmptyPlaceHolder } from "../../../../components/EmptyPlaceHolder"
import { BSParkingContext } from "../context/BSParkingContext"
import { BSParkingListContext } from "../context/BSParkingListContext"
import { BSParkingCard } from "./BSParkingCard"
import { BSParkingFormDialog } from "./BSParkingFormDialog"
import { SquareBadge } from "../../../../../../../../../components/badges/SquareBadge"

export function BSParkingNoBimContainer(): React.JSX.Element {
  const { isParkingFormOpen, setIsParkingFormOpen } = useContext(BSParkingContext)
  const { bsParkingList, isBSParkingListLoading } = useContext(BSParkingListContext)

  const [isUpdateMode, setIsUpdateMode] = useState(false)

  const handleOpenDialog: () => void = useCallback(() => {
    setIsParkingFormOpen(true)
    setIsUpdateMode(false)
  }, [setIsParkingFormOpen])

  return isBSParkingListLoading ? (
    <Box display="flex" justifyContent="center" alignItems="center" width="100%" height="85%">
      <CircularProgress />
    </Box>
  ) : (
    <Box
      border={1}
      borderRadius={3}
      p={3}
      borderColor={customPalette.paperBackground}
      boxShadow="0px 1px 3px rgba(0, 0, 0, 0.08)"
      width="100%"
      sx={{ backgroundColor: customPalette.white }}>
      <Box sx={{ py: 1, mb: 1 }}>
        <Typography>Ajoutez les parkings disponibles dans le bâtiment puis renseignez leurs informations.</Typography>
      </Box>

      {bsParkingList?.length === 0 ? (
        <EmptyPlaceHolder title="Aucun parking pour le moment" />
      ) : (
        <>
          <Box display="flex" alignItems="center" gap={2} mb={2}>
            <Typography variant="body2" fontWeight="600">
              Parkings ajoutés au bâtiment
            </Typography>
            <SquareBadge
              content={bsParkingList.length}
              color={customPalette.lightBlue5}
              backgroundColor={customPalette.lightBlue1}
            />
            <Box
              sx={{
                flexGrow: 1,
                height: "2px",
                backgroundColor: customPalette.paperBorder,
                marginLeft: "6px",
              }}
            />
          </Box>

          <Box display="flex" flexDirection="column" alignItems="center">
            {bsParkingList?.map((parking) => (
              <BSParkingCard
                key={parking.id}
                bsParking={parking}
                setIsOpen={setIsParkingFormOpen}
                setIsUpdateMode={setIsUpdateMode}
              />
            ))}
          </Box>
        </>
      )}
      <Box display="flex" justifyContent="end" p={1}>
        <BaseButton label="Ajouter un parking" onClick={handleOpenDialog} icon={AddIcon} />
      </Box>
      <BSParkingFormDialog isOpen={isParkingFormOpen} setIsOpen={setIsParkingFormOpen} isUpdateMode={isUpdateMode} />
    </Box>
  )
}
